"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../utils/constants");

var cmpResponseSites = function cmpResponseSites() {
  var _window = window,
      SibboCMP = _window.SibboCMP,
      consents = _window.consents,
      localStorage = _window.localStorage;
  var response = _constants.CMP.notAnswer;

  try {
    if (!(SibboCMP === null || SibboCMP === void 0 ? void 0 : SibboCMP.isOpen()) && consents) {
      if (consents.purposeAccepted) {
        response = _constants.CMP.configAccept;
      } else if (consents.purposeRejected) {
        response = _constants.CMP.configRejected;
      } else {
        response = _constants.CMP.configCustom;
      }

      if (localStorage && typeof localStorage !== 'undefined') {
        localStorage.setItem(_constants.EVAR109_NAME, response);
      }
    }
  } catch (_unused) {
    console.log('Valor del cmp: ', localStorage.getItem(_constants.EVAR109_NAME) || response);
  }

  return {
    respuestaCmp: localStorage.getItem(_constants.EVAR109_NAME) || response
  };
};

cmpResponseSites.id = 'respuestaCmp';
var _default = cmpResponseSites;
exports["default"] = _default;